import { Spin, notification } from "antd";
import React, { useEffect } from "react";
import { useGetFileQuery } from "../../store/api/apiSlice";
import RuleLayout from "../../components/layout/RuleLayout";

const PrivacyPolicy = () => {
  const pdfKey = "privacyStatement.pdf";
  const videoKey = "privacyStatementVideo.mp4";

  const {
    data: pdfUrl,
    isLoading: pdfLoading,
    error: pdfError,
  } = useGetFileQuery(pdfKey);

  const {
    data: videoUrl,
    isLoading: videoLoading,
    error: videoError,
  } = useGetFileQuery(videoKey);

  useEffect(() => {
    if (pdfError || videoError) {
      notification.error({
        message: "Failed to load content",
        description: "Unable to fetch the privacy policy content.",
      });
    }
  }, [pdfError, videoError]);

  const getPdfEmbedUrl = (url) => {
    const rawUrl = url?.file || url;
    if (!rawUrl) return "";

    const joiner = rawUrl.includes("#") ? "&" : "#";
    return `${rawUrl}${joiner}toolbar=0&navpanes=0&scrollbar=0&view=FitH`;
  };

  return (
    <RuleLayout title="Welcome to Unzippd's Privacy Policy">
      {videoLoading && <Spin tip="Loading video..." />}
      {videoUrl && !videoLoading && (
        <video
          src={videoUrl.file || videoUrl}
          autoPlay
          loop
          muted
          playsInline
          className="w-full max-h-[80vh] rounded-xl mb-8"
        />
      )}
      {pdfLoading && <Spin tip="Loading PDF..." />}
      {pdfUrl && !pdfLoading && (
        <iframe
          src={getPdfEmbedUrl(pdfUrl)}
          title="Privacy Policy PDF"
          className="w-full rounded-xl"
          height="800px"
          style={{ border: "1px solid #ccc" }}
        />
      )}
    </RuleLayout>
  );
};

export default PrivacyPolicy;
